import { render, staticRenderFns } from "./Abonados.vue?vue&type=template&id=52ce7cf5"
import script from "./Abonados.vue?vue&type=script&lang=js"
export * from "./Abonados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports